__turbopack_context__.v({
  "banner": "InfoBanner-module__tih96W__banner",
  "icon": "InfoBanner-module__tih96W__icon",
});
